module.exports = __webpack_public_path__ + "static/media/img_shelf_board_large.1e7544f5.png";